import { render, staticRenderFns } from "./InvoiceClientDetails.vue?vue&type=template&id=349ba8a4&"
import script from "./InvoiceClientDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports